var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"help-center fd-c f--c"},[_c('h1',[_vm._v(_vm._s(_vm.$t('Home.helpCenter.SearchHead.HELPCENTER')))]),_c('el-input',{staticStyle:{"width":"730px"},attrs:{"prefix-icon":"el-icon-search"},on:{"change":_vm.handleSearch},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }